import { IApp, ISwitchableValue } from '@todesktop/shared';

export type CreateNewAppProps = {
  id: string;
  appModelId: string;
  appType: 'electron';
  name: string;
};

export const readSwitchableValue = <T>(
  value: ISwitchableValue<T>,
  fallback: any = null,
) => {
  return value && value.enabled ? value.value : fallback; // TODO null is temporary, as firebase doesn't support undefined
};

export const isSwitchableEnabled = <T>(value: ISwitchableValue<T>) => {
  return value && value.enabled;
};

export const convertToNullIfEmpty = (value: any) =>
  value === undefined ? null : value;

export const defaultIcon =
  'https://download.todesktop.com/default-icons/blank-icon.png';

/** A v2 app (v2/FIRESTORE.md): what it ships is in its todesktop.config.ts. */
export function createV2App({ id, name }: { id: string; name: string }) {
  return {
    appType: 'v2',
    createdAt: new Date().toISOString(),
    icon: defaultIcon,
    id,
    meta: { publishedVersions: {} },
    name: name || 'My App',
  } as unknown as IApp;
}

export function createElectronApp(appProps: CreateNewAppProps) {
  const { name, id, appType } = appProps;

  const electronApp = {
    id,
    name: name || 'My App',
    appType,
    icon: defaultIcon,
    meta: {
      publishedVersions: {},
    },
    shouldCreateAppImages: true,
    shouldCreateMacZipInstallers: true,
    shouldCreateMacUniversalInstaller: true,
    shouldCreateAppleSiliconAssets: true,
    shouldCreateAppleIntelArtifacts: true,
    shouldCreateNSISInstallers: true,
  };

  return electronApp as IApp;
}
